import { i18n } from "translate/i18n";

export const reportError = i18n.t("messages.reportError.reportError");
export const tellUs = i18n.t("messages.reportError.tellUs");
export const whatHappened = i18n.t("messages.reportError.whatHappened");
